import { Link } from 'react-router-dom';
import { cn } from '../ui/cn';
import { ReactNode } from 'react';

type Props = {
	children?: ReactNode;
	text?: string;
	id?: string;
	link?: string;
	className?: string;
} & ({ children?: never; text: string } | { children: ReactNode; text?: never });

export const TextLink = ({
	className,
	link = '#',
	onClick,
	target,
	text,
}: Props & {
	onClick?: () => void;
	target?: string;
}) => {
	return (
		<Link to={link} onClick={onClick} target={target}>
			<p className={className}>{text}</p>
		</Link>
	);
};

export const SpanLink = ({
	className,
	link = '#',
	target,
	text,
}: Props & { target?: string }) => {
	return (
		<Link to={link} target={target}>
			<span className={className}>{text}</span>
		</Link>
	);
};

const createText = (
	as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span',
	fontClass?: string
) => ({ children, text, className }: Props) => {
	const Tag = as ?? 'p';
	const classes = cn('font-poppins', fontClass, className);
	return <Tag className={classes}>{children || text}</Tag>;
};

export const CustomText = createText('p');
export const ButtonLabel = createText('p', 'text-label-large font-medium');
export const TextTableHeader = createText('p', 'text-table-header');

export const TextHeadlineExtraSmall = createText('p', 'text-headline-x-small');
export const TextHeadlineSmall = createText('h1', 'text-headline-small');
export const TextHeadlineMedium = createText('h1', 'text-headline-medium');
export const TextHeadlineLarge = createText('h1', 'text-headline-large');
export const TextHeadlineExtraLarge = createText('h1', 'text-headline-x-large');
export const TextHeadlineExtraExtraLarge = createText('h1', 'text-headline-xx-large');
export const TextHeadlineExtraExtraLarge2 = createText('h1', 'text-headline-xx-large2');
export const TextLabelExtraSmall = createText('p', 'text-label-x-small');
export const TextCaption = createText('span', 'text-caption');
export const TextLabelSmall = createText('p', 'text-label-small font-normal');
export const TextLabelSmall2 = createText('p', 'text-label-small2');
export const TextLabelMedium = createText('p', 'text-label-medium font-medium');
export const TextLabelMedium2 = createText('p', 'text-label-medium');
export const TextLabelLarge = createText('p', 'text-label-large font-medium');
export const TextLabelLarge2 = createText('p', 'text-label-large2');
export const TextTitleSmall2 = createText('h5', 'text-title-small2 font-normal');
export const TextTitleMedium2 = createText('h5', 'text-title-medium2 font-normal');
export const TextTitleLarge2 = createText('h5', 'text-title-large2');
export const TextBodyExtraExtraSmall = createText('p', 'text-body-xx-small');
export const TextBodyExtraSmall = createText('p', 'text-body-x-small');
export const TextBodyExtraSmall2 = createText('p', 'text-body-x-small2');
export const TextBodySmall = createText('p', 'text-body-small');
export const TextBodyMedium = createText('p', 'text-body-medium');
export const TextBodyLarge = createText('p', 'text-body-large');
